import type { ImageRef } from './types';

export interface CareerJob {
  title: string;
  slug: string;
  location: string;
  department?: string;
  employmentType?: string;
  applyUrl: string;
  description?: string;
  sortOrder?: number;
}

export const careersHero = {
  eyebrow: 'Work at nsave',
  title: 'nsave is on a mission to democratise safe and secure financial services for all.',
  image: {
    src: '/images/careers/nsave_team_060825-20-1-.jpg',
    alt: 'Picture of the nsave team',
    srcSet: [
      { src: '/images/careers/nsave_team_060825-20-1-p-500.jpg', width: 500 },
      { src: '/images/careers/nsave_team_060825-20-1-p-800.jpg', width: 800 },
      { src: '/images/careers/nsave_team_060825-20-1-p-1080.jpg', width: 1080 },
      { src: '/images/careers/nsave_team_060825-20-1-p-1600.jpg', width: 1600 },
      { src: '/images/careers/nsave_team_060825-20-1-p-2000.jpg', width: 2000 },
      { src: '/images/careers/nsave_team_060825-20-1-.jpg', width: 2080 },
    ],
  } satisfies ImageRef & {
    srcSet: Array<{ src: string; width: number }>;
  },
};

export const careersOpenPositions = {
  title: 'Open positions',
};

export const careersLife = {
  title: 'Life at nsave',
  paragraphs: [
    "We're a growing team of developers, designers, and operators spread across the communities we serve. We build for people navigating real barriers in the financial system, so doing that from a distance was never an option.",
    "We hire people who understand those communities firsthand, who care deeply about their craft, and who want to be close to the problems they're solving. That closeness to each other and to our customers is how we keep shipping work that actually matters.",
    'Join us as we shift the financial sector from exclusion to action. This is your story and ours. We’re honoured to have you.',
  ],
  closing: 'We’re honoured to have you.',
};

export const careersMeta = {
  title: 'Careers at nsave',
  description:
    'Explore careers at nsave. Join a fast-growing fintech building global USD banking solutions for freelancers and remote workers worldwide.',
};
